import './live-item.css';

import { useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';
import styled from 'styled-components';

import { LESSON_TYPE } from '@/application/commons/enums/live.enum';
import { LiveStreamingDto } from '@/application/interfaces/pegasus.gateway';
import { MixpanelContentLessonCardClick, Tracking } from '@/application/utils/tracking';

import { LiveItemViewModel } from './live-item.vm';

const HighlightCardContainer = styled.div`
  display: flex;
  height: 15.25rem;
  padding: 2rem 2.5rem 1.5rem 2.5rem;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 1rem;
  flex: 1 0 0;
  color: whitesmoke;

  @media (max-width: 425px) {
    height: 13.25rem;
  }

  position: relative;
  border-radius: 0.5rem;
  ::before {
    content: '';
    position: absolute;
    aspect-ratio: 16 / 9;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 548px;
    max-height: 244px;
    height: fit-content;

    border-radius: 0.5rem;
    background-image: url(${({ backgroundURL }: { backgroundURL: string }) => backgroundURL});
    background-size: cover;
    background-color: black;
    background-clip: border-box;
    opacity: 0.5;
  }
`;

const InsideContainer = styled.div`
  font-family: Aprova Nova;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 425px) {
    gap: 0.1rem;
  }
`;

const InsideButton = styled.button`
  font-family: Aprova Nova;
  border: none;
  cursor: pointer;
  position: relative;
  font-size: 14px;
  font-weight: 700;
  height: 38px;
  width: 206px;
  border-radius: 300px;
  padding: 0px 24px;
  background-color: #00f99d;
  color: #191a1a;
  top: 1rem;
`;

interface HighlightCardProps {
  status: string;
  liveStreaming: LiveStreamingDto;
}

const getLiveLessonUrl = (courseGuid: string, streamingGuid: string) => {
  return `/classroom/live/course/${courseGuid}/${streamingGuid}`;
};

const trackingEvent = (liveStreaming: LiveStreamingDto) => {
  const props: MixpanelContentLessonCardClick = {
    course: liveStreaming.course.slug,
    course_id: liveStreaming.course.guid,
    course_name: liveStreaming.course.name,
    lesson: liveStreaming.slug,
    lesson_id: liveStreaming.streaming.guid,
    lesson_name: liveStreaming.name,
    lesson_type: LESSON_TYPE.LIVE,
    teacher: liveStreaming?.teacher,
    level_1: '',
    level_name_1: '',
    level_2: '',
    level_name_2: '',
    level_3: '',
    level_name_3: '',
    student_id: liveStreaming.student_id,
    user: liveStreaming.user,
    email: liveStreaming.email,
  };
  Tracking.contentLessonCardClick(props);
};

const LiveItem = ({ status, liveStreaming, ...props }: HighlightCardProps) => {
  const vm = useViewModel(LiveItemViewModel);

  if (vm.user) {
    liveStreaming.user = vm.user.name;
    liveStreaming.student_id = vm.user.guid;
    liveStreaming.email = vm.user.email;
  }

  return (
    <HighlightCardContainer
      className="highlight-card-container"
      backgroundURL={liveStreaming?.thumbnail}
      {...props}
    >
      <InsideContainer>
        <div className="highlight-card-status">
          <span className="highlight-card-icon-status"></span>
          <p className="highlight-card-text-status">{status}</p>
        </div>
        <h1 className="highlight-card-title">{liveStreaming.name}</h1>
        <h2 className="highlight-card-subtitle">{liveStreaming?.teacher}</h2>
        <InsideButton
          onClick={() => {
            trackingEvent(liveStreaming);
            window.location.href = getLiveLessonUrl(
              liveStreaming.course.guid,
              liveStreaming.streaming.guid,
            );
          }}
        >
          Assistir Agora
        </InsideButton>
      </InsideContainer>
    </HighlightCardContainer>
  );
};

export default LiveItem;
